import { PathnameUrl } from "@app/constants";
import InfoLayout from "./info-layout";
import { TERMS_SECTIONS, TERMS_UPDATED } from "./terms-content";

/*
 * Trang Điều khoản dịch vụ, cùng khung với Giới thiệu / Liên hệ.
 * Nội dung chép nguyên văn từ views/term_of_service.ejs của API (terms-content.tsx), đừng tự sửa chữ.
 */

function TermsPage() {
  return (
    <InfoLayout
      current={PathnameUrl.TERMS}
      title="Điều khoản"
      docTitle="Điều khoản Dịch vụ của PC Render"
    >
      <section className="hero" aria-labelledby="t">
        <h1 id="t">Điều Khoản Dịch Vụ</h1>
        <p className="lead">{TERMS_UPDATED}</p>
        <nav className="toc" aria-label="Mục lục">
          {TERMS_SECTIONS.map(({ id, title }, i) => (
            <a key={id} href={`#${id}`}>
              <span className="no">{i + 1}</span>
              {title}
            </a>
          ))}
        </nav>
      </section>

      <article className="doc">
        {TERMS_SECTIONS.map(({ id, title, body }, i) => (
          <section
            key={id}
            id={id}
            className="doc-sec"
            aria-labelledby={`${id}-t`}
          >
            <h2 id={`${id}-t`}>
              <span className="no">{i + 1}</span>
              {title}
            </h2>
            {body}
          </section>
        ))}
      </article>
    </InfoLayout>
  );
}

export default TermsPage;
